import { useState } from 'react'

import { env } from 'src/config/env'
import { Headset } from 'src/shared/components/icons/headset'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { useWindowSize } from 'src/shared/hooks/use-window-size'
import { cn } from 'src/shared/utils/cn'

import { SupportDialogControlled } from '../../support/components/support-dialog'

import EnterpriseAuthSideContent from './side-content'

interface EnterpriseAuthLayoutProps {
  children: React.ReactNode
  variant?: 'default' | 'consumer'
}

export default function EnterpriseAuthLayout({ children, variant = 'default' }: EnterpriseAuthLayoutProps) {
  const { isMobile } = useBreakpoint()
  const { width } = useWindowSize()
  const [supportDialogOpen, setSupportDialogOpen] = useState(false)

  const handleHelpClick = () => {
    setSupportDialogOpen(true)
  }

  const handlePrivacyPolicyClick = () => {
    window.open(env.LINK_TO_PRIVACY_POLICY, '_blank')
  }

  if (isMobile) {
    return <div className="flex min-h-screen w-full bg-white px-5">{children}</div>
  }

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center bg-[#F8F7F5] px-5 xs:px-8 xs:py-16">
      <div
        className={cn(
          'mx-auto flex min-h-[750px] w-full max-w-[1330px] flex-row gap-[30px]',
          width < 1000 && 'mt-2 min-h-[1500px] flex-col',
          width < 1000 && variant === 'consumer' && 'mb-5 mt-0',
        )}
      >
        {children}
        <EnterpriseAuthSideContent variant={variant} />
      </div>
      {variant === 'default' && (
        <div className="absolute right-[35px] top-[28px] flex flex-row items-center text-[14px] text-muted">
          <Headset size={20} className="mr-2 text-primary" />
          {'Need help?'}
          <div className="cursor-pointer" onClick={handleHelpClick}>
            <p className="ml-1 text-primary underline">{'Click here'}</p>
          </div>
        </div>
      )}
      {variant === 'consumer' && (
        <div className="absolute inset-x-0 bottom-0 flex flex-row items-center justify-end gap-10 px-[43px] py-[34px] text-[13px] text-muted">
          <div className="cursor-pointer" onClick={handleHelpClick}>
            <p>{'Need help'}</p>
          </div>
          <div className="cursor-pointer" onClick={handlePrivacyPolicyClick}>
            <p>{'Privacy policy'}</p>
          </div>
        </div>
      )}
      <SupportDialogControlled open={supportDialogOpen} setOpen={setSupportDialogOpen} />
    </div>
  )
}
